import { render, staticRenderFns } from "./RefrigerantHealth.vue?vue&type=template&id=f59df99a&scoped=true&"
import script from "./RefrigerantHealth.vue?vue&type=script&lang=js&"
export * from "./RefrigerantHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59df99a",
  null
  
)

export default component.exports